import { useCallback, useEffect, useRef, useState } from "react";
import { http, toastApiError, downloadUrl } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { toast } from "../lib/notify";
import { Upload, FileText, Trash2 } from "lucide-react";

export default function AssetTutanakArchive({ assetId, isAdmin }) {
  const [docs, setDocs] = useState([]);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  const load = useCallback(() => http.get(`/fixed-assets/${assetId}/tutanak-archive?doc_type=tutanak`).then((r) => setDocs(r.data)).catch(() => {}), [assetId]);
  useEffect(() => { load(); }, [load]);
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try { await http.post(`/fixed-assets/${assetId}/tutanak-archive`, fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("İmzalı tutanak arşivlendi"); load(); }
    catch (e) { toastApiError(e); } finally { setBusy(false); }
  };
  const remove = async (d) => {
    if (!window.confirm("Arşivdeki tutanak silinsin mi?")) return;
    try { await http.delete(`/asset-documents/${d.id}`); load(); } catch (e) { toastApiError(e); }
  };
  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/60 p-3" data-testid="asset-tutanak-archive">
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="text-[11px] font-bold uppercase tracking-wide text-slate-600">Tutanak Arşivi <span className="font-normal normal-case text-slate-500">— imzalanmış tutanağı tarayıp yükleyin (PDF/JPG/PNG)</span></div>
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid="asset-tutanak-upload" className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-slate-900 text-white text-[11px] font-semibold hover:bg-slate-800 disabled:opacity-60"><Upload className="w-3.5 h-3.5" /> {busy ? "Yükleniyor…" : "İmzalı Tutanak Yükle"}</button>
        <input ref={ref} type="file" accept=".pdf,image/*" className="hidden" data-testid="asset-tutanak-upload-input" onChange={(e) => { if (e.target.files?.[0]) upload(e.target.files[0]); e.target.value = ""; }} />
      </div>
      {docs.length === 0 ? <div className="text-xs text-slate-500" data-testid="asset-tutanak-archive-empty">Arşivde tutanak yok.</div> : (
        <ul className="divide-y divide-slate-200">
          {docs.map((d) => (
            <li key={d.id} className="py-1.5 flex items-center justify-between gap-3 text-xs" data-testid={`asset-tutanak-doc-${d.id}`}>
              <a href={downloadUrl(`/asset-documents/${d.id}/file`)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-rose-700 hover:underline font-semibold"><FileText className="w-3.5 h-3.5" /> {d.original_filename}</a>
              <span className="text-slate-500">{d.personnel_name || "—"} · {fmtDateTime(d.created_at)} · {d.created_by}</span>
              {isAdmin && <button type="button" onClick={() => remove(d)} data-testid={`asset-tutanak-doc-delete-${d.id}`} className="text-red-700 hover:text-red-900"><Trash2 className="w-3.5 h-3.5" /></button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
